// frontend/src/components/ErrorBanner.jsx
import React from "react";
import PropTypes from "prop-types";

/**
 * ErrorBanner — full-width red banner that shows an error message with an
 * optional "Retry" button.
 *
 * @param {{ message: string, onRetry?: () => void }} props
 */
function ErrorBanner({ message, onRetry }) {
  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
    >
      <span>{message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          className="shrink-0 rounded-md border border-red-300 bg-white px-3 py-1 text-xs font-medium text-red-700 hover:bg-red-50 transition-colors"
        >
          Retry
        </button>
      )}
    </div>
  );
}

ErrorBanner.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
};

export default ErrorBanner;
